import axios from 'axios'
import $ from 'jquery'
import {
	MessageBox,
} from 'element-ui'
import {
	Loading
} from 'element-ui';
import router from './src/router/index.js';
axios.defaults.timeout = 60000; //响应时间
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'; 
//axios.defaults.baseURL = 'http://192.168.1.160:8082/dgj';  //配置接口地址 */
axios.defaults.baseURL = 'https://doc.taxunion.com.cn:8080/doc'; //配置接口地址
//axios.defaults.baseURL = 'http://192.168.1.160:8002/dgj';
//axios.defaults.baseURL = 'http://192.168.23.97:8012/dgj';
//axios.defaults.baseURL = 'https://kjdzda.hspharm.com:8002/dgj';
//	POST传参序列化(添加请求拦截器)
// axios.interceptors.request.use((config) => {
// 	//在发送请求之前做某件事
// 	var qs = require('querystring');
//     if(config.method  === 'post'){
//         config.data = qs.stringify(config.data);
//     }
//     return config;
// },(error) =>{
//     console.log('错误的传参')
//     return Promise.reject(error);
// });

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
	//对响应数据做些事
	if (!res.data.success) {
		return Promise.resolve(res);
	}
	return res;
}, (error) => {
	return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
	var token = localStorage.getItem('token');
	var verifyCodeToken = localStorage.getItem('jwttokenverifycode');
	const loading = Loading.service({
		lock: true,
		text: 'loading……',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token;
	}
	if (verifyCodeToken) {
		axios.defaults.headers.common['jwttokenverifycode'] = verifyCodeToken;
	}
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(response => {
				loading.close();
				if (response.data.msg == "用户连接超时" || response.data.code == "2018") {
				 	localStorage.removeItem("token")
					router.push('/login');
				}else{
					resolve(response);
				}
				// if (response.data.message && (response.data.message.indexOf('Session time out.') != -1 || response.data.message.indexOf('no token.') != -1)) {
				// 	localStorage.removeItem('token');
				// 	// this.$route.push('/');
				// 	router.push('/');
				// } else {
				// 	resolve(response);
				// }
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	})
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
	var token = localStorage.getItem('token')
	const loading = Loading.service({
		lock: true,
		text: 'loading……',
		background: 'rgba(0, 0, 0, 0.7)'
	})
	if (token != "" & token != null) {
		axios.defaults.headers.common['token'] = token;
	}
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: param
			})
			.then(response => {
				loading.close();
				if (response.data.msg == "用户连接超时" || response.data.code == "2018") {
				 	localStorage.removeItem("token")
					router.push('/login');
				}else{
					resolve(response);
				}
			}, err => {
				reject(err)
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export default {
	fetchPost,
	fetchGet,
}
